import React from "react";
import { Paper } from "@material-ui/core";
import MaterialTable from "material-table";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import StockIcon from "@material-ui/icons/AllInbox";
import products from "../../service/products";
import { getTenant } from "../../libs/tenant";
import { formatQuantity } from "../../libs/format";
import ProductDialog from "./ProductDialog";
import StockDialog from "./StockDialog";
import ConfirmDialog from "../alertas/Confirm";
import SuccessAlert from "../alertas/SuccessAlert";
import DialogError from "../alertas/DialogError";

// Catálogo global: todos os produtos da empresa (independente de grupo).
// Props: enterpriseId, onBack().
class AllProductsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { title: "id", field: "id", hidden: true },
        { title: "Nome", field: "name" },
        { title: "Categoria", field: "category" },
        { title: "Unidade", field: "unit_of_measure" },
        { title: "Moeda", field: "currency" },
        {
          title: "Saldo",
          field: "current_stock",
          render: (row) => formatQuantity(row.current_stock),
        },
        {
          title: "Catálogos",
          field: "groups",
          render: (row) =>
            (row.groups || []).map((g) => g.name).join(", "),
        },
      ],
      data: [],
      loading: false,
      productDialog: false,
      editingProduct: null,
      stockProduct: null,
      confirmDelete: null,
      successMessage: "",
      showError: false,
      error: null,
    };
  }

  componentDidMount() {
    this.load();
  }

  load = () => {
    this.setState({ loading: true });
    products
      .listAllProducts(getTenant())
      .then((data) => this.setState({ data, loading: false }))
      .catch(() => this.setState({ loading: false }));
  };

  handleSaved = () => {
    this.setState({
      productDialog: false,
      editingProduct: null,
      successMessage: "Produto salvo.",
    });
    this.load();
  };

  deleteProduct = () => {
    const product = this.state.confirmDelete;
    products
      .deleteProduct(product.id)
      .then(() => {
        this.setState({ confirmDelete: null, successMessage: "Produto excluído." });
        this.load();
      })
      .catch((err) => {
        this.setState({
          confirmDelete: null,
          showError: true,
          error: {
            title: "Erro ao excluir",
            message: (err && err.data && err.data.message) || "Falha ao excluir.",
          },
        });
      });
  };

  render() {
    return (
      <Paper>
        {this.state.productDialog && (
          <ProductDialog
            enterpriseId={this.props.enterpriseId}
            product={this.state.editingProduct}
            close={() =>
              this.setState({ productDialog: false, editingProduct: null })
            }
            save={this.handleSaved}
          />
        )}
        {this.state.stockProduct && (
          <StockDialog
            product={this.state.stockProduct}
            close={() => this.setState({ stockProduct: null })}
            onChanged={(currentStock) =>
              this.setState({
                data: this.state.data.map((r) =>
                  r.id === this.state.stockProduct.id
                    ? { ...r, current_stock: currentStock }
                    : r
                ),
              })
            }
          />
        )}
        {this.state.confirmDelete && (
          <ConfirmDialog
            title="Atenção"
            body={`Excluir o produto "${this.state.confirmDelete.name}" de toda a empresa? Ele sairá de todos os catálogos.`}
            handleCloseConfirmT={this.deleteProduct}
            handleCloseConfirmF={() => this.setState({ confirmDelete: null })}
          />
        )}
        <SuccessAlert
          open={!!this.state.successMessage}
          message={this.state.successMessage}
          onClose={() => this.setState({ successMessage: "" })}
        />
        <DialogError
          open={this.state.showError}
          onClose={() => this.setState({ showError: false })}
          title={this.state.error ? this.state.error.title : "Erro"}
          message={this.state.error ? this.state.error.message : ""}
          suggestion={"Tente novamente."}
        />
        <MaterialTable
          title="Todos os produtos"
          columns={this.state.columns}
          data={this.state.data}
          isLoading={this.state.loading}
          options={{ search: true, actionsColumnIndex: -1 }}
          localization={{
            header: { actions: "Ações" },
            body: { emptyDataSourceMessage: "Nenhum produto cadastrado." },
          }}
          actions={[
            {
              icon: () => <ArrowBackIcon />,
              tooltip: "Voltar",
              isFreeAction: true,
              onClick: () => this.props.onBack(),
            },
            {
              icon: () => <AddIcon />,
              tooltip: "Novo produto",
              isFreeAction: true,
              onClick: () =>
                this.setState({ productDialog: true, editingProduct: null }),
            },
            {
              icon: () => <EditIcon />,
              tooltip: "Editar produto",
              onClick: (event, row) =>
                this.setState({ productDialog: true, editingProduct: row }),
            },
            {
              icon: () => <StockIcon />,
              tooltip: "Estoque",
              onClick: (event, row) => this.setState({ stockProduct: row }),
            },
            {
              icon: () => <DeleteIcon />,
              tooltip: "Excluir da empresa",
              onClick: (event, row) => this.setState({ confirmDelete: row }),
            },
          ]}
        />
      </Paper>
    );
  }
}

export default AllProductsList;
